import { Components, ThisGorillaUtils } from "@thisgorilla/primate-ds";
import { useState } from "react";
import { styled, useTheme } from "styled-components";
import { WithHeightTransition } from "../../../../HOC/WithHeightTransition";
import {
  FlexColumn,
  FlexColumnWithTransition,
  FlexRow,
  FlexRowWithFlow,
} from "../../Styles";

export const CommonInterests = () => {
  const [containerHeight, setContainerHeight] = useState(0);

  const [showCommonInterests, setShowCommonInterests] = useState(false);
  const { typography, Color, spacing } = useTheme();

  const industries = [
    "Fintech",
    "IT",
    "Healthcare",
    "Education",
    "SaaS",
    "Tech",
    "Software development",
    "Jobtech",
  ];
  const interests = [
    "Product Design",
    "UX Design",
    "UI Design",
    "Software",
    "Tech",
    "Venture capital",
    "AI",
  ];
  const padding = ThisGorillaUtils.convertRemToPx(spacing["spacing-2"].value);

  return (
    <Container
      $height={padding + containerHeight + padding}
      $transitionDuration={150}
    >
      <WithHeightTransition setContainerHeight={setContainerHeight}>
        <FlexColumn $gapInPx={8}>
          <Title
            $gapInPx={8}
            onClick={() => setShowCommonInterests((prev) => !prev)}
            key={"title"}
          >
            <TextAndCount>
              <Components.Text
                text="Common interests"
                style={{ tokenStyle: typography.Heading.XXS }}
                fontWeight="font-weight-semibold"
              />
              <Components.Counter
                count={11}
                size="Small"
                color="Dark"
                kind="Fill"
              />
            </TextAndCount>
            <Components.Icon
              type={showCommonInterests ? "ChevronUp" : "ChevronDown"}
              size="16px"
            />
          </Title>

          {showCommonInterests && (
            <CommonInterestsContainer $gapInPx={8} key={"commonInterests"}>
              <ChipsContainer $gapInPx={8}>
                <Components.Text
                  text="Industries"
                  style={{ tokenStyle: typography.Heading.XXS }}
                  color={Color.background.brand.default.value}
                  fontWeight="font-weight-semibold"
                />
                <ChipsWrapper $gapInPx={8}>
                  {industries.map((industry, index) => (
                    <Components.Chip
                      content={industry}
                      kind="Primary"
                      key={industry + index}
                      renderInSingleLine
                    />
                  ))}
                </ChipsWrapper>
              </ChipsContainer>

              <ChipsContainer $gapInPx={8}>
                <Components.Text
                  text="Interests"
                  style={{ tokenStyle: typography.Heading.XXS }}
                  color={Color.background.positive.default.value}
                  fontWeight="font-weight-semibold"
                />
                <ChipsWrapper $gapInPx={8}>
                  {interests.map((interest, index) => (
                    <Components.Chip
                      content={interest}
                      kind="Positive"
                      key={interest + index}
                      renderInSingleLine
                    />
                  ))}
                </ChipsWrapper>
              </ChipsContainer>
            </CommonInterestsContainer>
          )}
        </FlexColumn>
      </WithHeightTransition>
    </Container>
  );
};

const Container = styled(FlexColumnWithTransition)`
  ${({ theme }) => {
    return `padding: ${theme.spacing["spacing-2"].value}rem;
      border-radius: ${theme.radius["radius-xxs"].value}rem;
      background: ${theme.Color.elevation.surface["surface-primary"].value};
      min-height: 34px;
    `;
  }}
`;
const Title = styled(FlexRow)`
  justify-content: space-between;
  cursor: pointer;
`;
const ChipsContainer = styled(FlexRow)`
  position: relative;
`;
const ChipsWrapper = styled(FlexRowWithFlow)`
  flex-wrap: wrap;
`;
const CommonInterestsContainer = styled(FlexColumn)``;
const TextAndCount = styled(FlexRow)``;
